import React from "react";
import PropTypes from "prop-types";
import { Box, P } from "orcs-design-system";

import { copywriting } from "./ErrorPage.config";

const SupportErrorDetails = ({ details }) => {
  if (!details) {
    return null;
  }

  return (
    <Box data-testid="support-error-details">
      <P>
        {copywriting.supportDiagnosticsLabel} {details}
      </P>
    </Box>
  );
};

SupportErrorDetails.propTypes = {
  details: PropTypes.string,
};

export default SupportErrorDetails;
